<template>
  <div class="content">
    <div class="reportTop">答题情况</div>
      <div class="reportCont flex">
          <div class="reportLeft">
<!--              <div v-if="report.score!==201" class="grade-box">-->
              <div  class="grade-box">
                  <el-progress type="circle" :stroke-width="18" :percentage="report.rate"></el-progress>
                  <div>正确率</div>
              </div>
          </div>
          <div class="reportRight" style="width: 500px; margin-top: 35px">
              <div style="font-size: 18px;margin-left: 40px; margin-bottom: 10px">
                  <span>用时：{{useTime}} 分钟 </span>
              </div>
              <div style="font-size: 18px;margin-left: 40px; margin-bottom: 10px">
<!--                  <span v-if="report.score==201">本次考试成绩：<p style="color: red">考试成绩于7月1日起公布</p></span>-->
<!--                <span v-else >本次考试成绩：{{report.score}} 分</span>-->
                  <span>本次考试成绩：{{report.score}} 分</span>
              </div>
              <div style="font-size: 18px; margin-left: 40px;margin-bottom: 10px">
                  <span>试卷总成绩：{{report.examNum}} 分</span>
              </div>
              <div style="font-size: 18px; margin-left: 40px;margin-bottom: 10px">
                <span>考试剩余次数：{{report.exam_count}} 次</span>
<!--                <span >已参与考试次数：{{report.exam_count}} 次</span>-->
              </div>
          </div>
      </div>
    <div class="reportBottom">
      <div class="btn" @click="goBack">返回</div>
<!--      <div v-if="report.score!==201" class="btn" @click="analysis()">查看解析</div>-->
      <div class="btn" @click="analysis()">查看解析</div>
      <!--<div class="btn" @click="analysis()">查看错题解析</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "report",
  data() {
    return {
      report: "",
      useTime:0,
        examDoId: undefined,
        examId: undefined
    };
  },
  mounted() {

    this.report = JSON.parse(this.$route.query.report);
      this.useTime = this.$route.query.userTime
      this.examId = this.$route.query.examId
  },
  methods: {
    analysis(){
        console.log(this.examId, "试卷ID")
      this.$router.push({
          path: "/analysis",
          query: {"examId": this.examId, "examDoId": this.report.examDoId}
          });
    },

      goBack() {
          this.$router.go(-1);
      },

  },
};
</script>
<style lang="less" scoped>

    /*.grade-box /deep/ .el-progress-circle {
        height: 226px;
        width: 226px;
    }*/
    .grade-box /deep/ .el-progress-circle__track {
        stroke: #938f8f;
    }

    .grade-box /deep/ .el-progress-circle__path {
        stroke: orangered;
    }

    .grade-box /deep/ .el-progress__text {
        font-size: 26px !important;

    }
.color {
  color: #ff9702 !important;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.reportTop {
    width: 1200px;
    height: 60px;
    margin-top: 20px;
    margin-bottom: 35px;
    border-radius: 20px 20px 0 0;
    /*height: 299px;*/
  font-size: 18px;
  text-align: center;
  line-height: 280px;
  color: rgba(255, 255, 255, 0.6);
    background-color: #ff6829; //;
    /*background-image: url("../../assets/img/study/exam/bg_1_10.png");*/
    background-position-y: -30px;
  background-repeat: no-repeat;
}

    /*.reportCont {*/
    /*color: #029aff;*/
    /*}*/

    .reportLeft {
        /*position: relative;*/
        width: 210px;
        height: 190px;
        .grade-box {
            /*background-image: url("../../assets/img/study/exam/bg_1_11.png");*/
            margin-left: 100px;
            width: 400px;
            height: 180px;
            text-align: center;
            background-repeat: no-repeat;
            border-right-width: 1px;
            border-right-style: solid;
            border-right-color: #dddd;
            div {
                font-size: 16px;
                margin-top: 10px;
            }
            /*div:first-child {*/
            /*padding-top: 25px;*/
            /*font-size: 70px;*/
            /*font-weight: bold;*/
            /*}*/
        }
    }

    .reportRight {
        /*.pass-box {*/
        /*!*width: 190px;*!*/
        /*!*height: 190px;*!*/
        /*line-height: 190px;*/
        /*text-align: center;*/
        /*color: #e67300;*/
        /*font-size: 45px;*/
        /*font-family: PingFang SC;*/
        /*font-weight: 500;*/
        /*}*/

    }


.reportBottom {
    margin-top: 70px;
  display: flex;
  justify-content: center;
  .btn {
    cursor: pointer;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
      border-radius: 50px;
      border: 1px solid #b9b9b9;
      color: #232323;
    &:first-child {
      margin-right: 100px;
    }
  }
  .btn:hover {
      background-color: #ff6829;
    color: #fff;
  }
}
</style>
